import type { OpportunityType } from '@/types/Opportunity'

/**
 * Query key factory for similar opportunities
 *
 * Follows react-query best practices for cache management:
 * - Hierarchical keys enable granular cache invalidation
 * - Type-safe keys prevent runtime errors
 * - Consistent structure across all similar opportunity queries
 */
export const similarOpportunityKeys = {
  /** Base key for all similar opportunities queries */
  all: ['similarOpportunities'] as const,

  /** Keys scoped by opportunity type */
  type: (type: OpportunityType) =>
    [...similarOpportunityKeys.all, type] as const,

  /** Keys for specific opportunity's similar results */
  detail: (type: OpportunityType, id: string) =>
    [...similarOpportunityKeys.type(type), id] as const,
}
